export const Filters = {
  Location: 'location',
  Distance: 'distance',
  Date: 'date',
  Sort: 'sort',
  Sport: 'sport',
  Tag: 'tag',
  Name: 'name',
  Covid: 'covid',
};
